// extracted by css-extract-rspack-plugin
export default {"divider":"FilterGroups-module__divider__O4OlR","topDivider":"FilterGroups-module__topDivider__bZxky","footerText":"FilterGroups-module__footerText__ToHbN"};